<template>
  <div class="content blacklist">
    <div class="header">
      <div class="row">
        <div class="box">
          <div class="title">关键词</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="screen.keyword">
          </el-input>
        </div>
        <div class="box">
          <div class="title">成交次数</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="screen.make_num">
          </el-input>
        </div>
        <div class="box">
          <div class="title">会员等级</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="screen.vip_status">
          </el-input>
        </div>
        <div class="box">
          <div class="title">申请时间</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="screen.create_time">
          </el-input>
        </div>
        
      </div>
      <div class="row">
        <div class="box">
          <div class="title">注册时间</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="screen.add_time">
          </el-input>
        </div>
        <div class="box">
          <div class="title">黑名单</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="screen.no_user">
          </el-input>
        </div>
        <div class="box">
          <div class="title">审核状态</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="screen.status">
          </el-input>
        </div>
      </div>
    </div>
    <template>
      <el-table border :data="list_all.data" style="width: 100%" size="small">
        <el-table-column prop="real_name" label="姓名" width="140"></el-table-column>
        <el-table-column prop="mobile" label="手机号" ></el-table-column>
        <el-table-column prop="name" label="等级" ></el-table-column>
        <el-table-column prop="refuse_reason" label="驳回原因" ></el-table-column>
        <el-table-column prop="order.order_amount" label="订单/金额" ></el-table-column>
        <el-table-column prop="order.order_num" label="订单/数量" ></el-table-column>
        <el-table-column prop="create_time" label="申请时间" ></el-table-column>
        <el-table-column prop="audit_time" label="审核时间" ></el-table-column>
        <el-table-column prop="status" label="申请状态" >
          <template slot-scope="scope">
            <el-tag size="medium" v-if="scope.row.status == 0">审核中</el-tag>
            <el-tag size="medium" type="success" v-if="scope.row.status == 1">审核通过</el-tag>
            <el-tag size="medium" type="warning" v-if="scope.row.status == 2">审核驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div class="cao-zuo" v-if="scope.row.status == 0 || scope.row.status == 2">
              <el-link type="success" @click="agree_open(scope.row.id)">同意</el-link>
              <el-link type="danger" @click="set_refued(scope.row.id)">拒绝</el-link>
            </div>
            <div class="cao-zuo" v-if="scope.row.status == 1">
              <span>无操作</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="page-next">
      <el-pagination layout="prev, pager, next" :total="list_all.total">
      </el-pagination>
    </div>
    <!--驳回申请-->
    <el-dialog title="驳回分销商申请" :visible.sync="dialogVisible" width="30%">
      <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="refuse_reason">
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="refuedCon">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getspread_list, RefueSeread, AgreeSeread } from "@/api/user";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      screen: {},
      list_all: {},
      dialogVisible: false,
      refuse_reason: "",
      now_idx: ""
    };
  },
  mounted() {
    this.getListArr();
  },
  methods: {
    // 获取数据
    async getListArr() {
      try {
        var data = {
          app_id: this.app_id
        }
        const res = await getspread_list(data);
        if (res.code == 200) {
          this.list_all = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    set_refued(val) {
      this.dialogVisible = true;
      this.now_idx = val; 
    },
    // 通过分销申请
    async agree_open(val) {
      try {
        var data = {
          app_id: this.app_id,
          id: val,
        }
        const res = await AgreeSeread(data);
        if (res.code == 200) this.$message.success(res.msg);
        else this.$message.error(res.msg);
        this.getListArr();
      } catch (error) {
        console.log(error);
      }
    },
    // 拒绝
    async refuedCon(index, row) {
      try {
        var data = {
          app_id: this.app_id,
          id: this.now_idx,
          refuse_reason: this.refuse_reason
        }
        const res = await RefueSeread(data);
        if (res.code == 200) this.$message.success(res.msg);
        else this.$message.error(res.msg);
        this.getListArr();
      } catch (error) {
        console.log(error);
      }
    },
    addSlice() {
      this.$router.push({
        path: `adAdvertisement`
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    padding: 10px 10px;
    
    .row{
      display: flex;
      padding: 6px 0;
    }
    .box{
      width: 25%;
      line-height: 40px;
      display: flex;
      .title{
        width:120px;
        padding-right: 20px;
        text-align: right;
      }
    }
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
  .cao-zuo {
    width: 60%;
    display: flex;
    padding: 0 20px;
    margin: 0 auto;
    justify-content: space-between;
  }
  .page-next {
    margin-top: 10px;
  }
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>
